import moment from "moment";
import documentService from "../../services/DocumentService";
export const stringToIntTime = (s) => {
  let tt = s.split(":");
  let h = parseInt(tt[0]);
  let m = parseInt(tt[1]);
  return parseInt(h * 60 + m);
};
export const getStringSlot = (slot) => {
  let hours = Math.floor(slot / 60);
  let minutes = slot % 60;
  let hourString = hours < 10 ? "0" + hours : hours;
  let minString = minutes < 10 ? "0" + minutes : minutes;
  return hourString + ":" + minString;
};
export const getExactDisplayName = (fmObj, appoint) => {
  let displayName = "Self";
  if (appoint.appointment.bookedFor !== 0) {
    if (fmObj[appoint.appointment.bookedFor]) {
      displayName = fmObj[appoint.appointment.bookedFor];
    } else {
      displayName = "";
    }
  }
  return displayName;
};

// TODO: fix below logic.
export const createDateAndChangeScreen = (minDayBooking, maxDayBooking) => {
  let minDays = minDayBooking || 0;
  let maxDays = maxDayBooking || 0;
  let dateArr = [];

  for (let i = 0; i < maxDays; i++) {
    let d = moment(new Date(new Date().setHours(12))).add(minDays + i, "days");
    let dateObj = {
      day: d.date(),
      month: moment(d).format("MMM"),
      exactDate: d,
    };
    dateArr.push(dateObj);
  }
  if (dateArr.length === 0) {
    let d = moment(new Date(new Date().setHours(12)));
    let dateObj = {
      day: d.date(),
      month: moment(d).format("MMM"),
      exactDate: d,
    };
    dateArr.push(dateObj);
  }
  return dateArr;
};

export const errorMessageHandler = (
  err,
  defaultMsg = "Something went wrong."
) => {
  let errMsg = defaultMsg;
  try {
    let msgArr = JSON.parse(err.message);

    if (msgArr.message) {
      errMsg = msgArr.message;
    }
  } catch (error) {
    if (err?.message) {
      errMsg = err.message;
    }
  }
  return errMsg;
};

export const getUrlWithToken = (url, token) => {
  if (url && url.indexOf("?") !== -1) {
    url = `${url}&token=${token}`;
  } else {
    url = `${url}?token=${token}`;
  }

  return url;
};

// ---------------------------------------------------------------------------
// Document upload + document->appointment mapping helpers.
//
// A booking that collects documents (e.g. the consultation ReasonScreen, or the
// Second Medical Opinion flow) attaches those documents to the appointment in
// two steps: upload each file to get a documentId, then map each documentId to
// the appointmentId. This runs only once the appointment exists — right away
// for FREE bookings, and post-payment for PAID bookings (in BookAfterPayment,
// which resolves the appointmentId from the get-appointments filter API).
// ---------------------------------------------------------------------------

// Uploads each collected file and returns the resulting documentIds.
// `files` items are `{ file, category }` — category "prescription" maps to
// document type 9, anything else (lab report) to 11. Skips files > 20MB.
export const uploadNavigoDocuments = async (files, patientId) => {
  const uploadedDocumentIds = [];
  if (!files || files.length === 0) return uploadedDocumentIds;

  for (const item of files) {
    const actualFile = item.file;
    if (!actualFile) continue;

    if (actualFile.size <= 20000000) {
      const document = {
        patientId: patientId,
        title: actualFile.name,
        description: "",
        format: 2,
        type: item.category === "prescription" ? 9 : 11,
        status: 4,
      };
      try {
        const response = await documentService.uploadDocument(
          actualFile,
          actualFile.name,
          document,
          null,
          patientId
        );
        const documentId = response?.data?.id;
        if (documentId) {
          uploadedDocumentIds.push(documentId);
        }
      } catch (error) {
        console.error("Document upload failed for:", actualFile.name, error);
      }
    } else {
      console.log("File size exceeds 20MB:", actualFile.name);
    }
  }

  return uploadedDocumentIds;
};

// Maps already-uploaded documentIds to an appointment (used on the free path
// and by BookAfterPayment once a paid appointment exists).
export const mapDocumentsToAppointment = async (appointmentId, documentIds) => {
  if (!appointmentId || !documentIds || documentIds.length === 0) return;
  await Promise.all(
    documentIds.map((id) =>
      documentService.documentMapping(appointmentId, id)
    )
  );
};
